import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-white py-8" data-id="element-73">
      <div className="container mx-auto px-4" data-id="element-74">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-75">
          <div className="mb-4 md:mb-0" data-id="element-76">
            <h2 className="text-xl font-bold text-blue-500" data-id="element-77">SportProZ</h2>
          </div>
          <div className="text-center md:text-right" data-id="element-78">
            <p className="text-gray-400" data-id="element-79">
              © {new Date().getFullYear()} SportProZ. All rights reserved.
            </p>
            <p className="text-gray-400" data-id="element-80">
              CONNECTING THE SPORTS WORLD THROUGH PROFESSIONAL NETWORKING
            </p>
          </div>
        </div>
      </div>
    </footer>;
}